import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconRunShortcut: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconRunShortcut"><Path fillRule="evenodd" clipRule="evenodd" d="M3 3H21V21H3V3ZM15.2489 6.89326L10.1067 17.7489L8.75113 17.1067L13.8933 6.25113L15.2489 6.89326Z" fill="currentColor"/></CentralIconBase>;
});

export default IconRunShortcut;
